module.exports = __webpack_public_path__ + "assets/img/hill-1.a5c2247a.png";